import React from "react";

export const HeroScreenshot = () => {
  return (
    <div className="w-full bg-neutral-950 rounded-2xl p-4 border border-neutral-800 shadow-2xl">
      {/* Top bar */}
      <div className="flex items-center gap-2 mb-4 px-1">
        <div className="flex gap-1.5">
          <div className="w-2.5 h-2.5 rounded-full bg-red-500" />
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" />
          <div className="w-2.5 h-2.5 rounded-full bg-green-500" />
        </div>
        <div className="flex-1 h-5 bg-neutral-800 rounded-md mx-4 flex items-center px-2">
          <span className="text-[10px] text-neutral-500">app.coldfire.io</span>
        </div>
      </div>

      {/* Main content */}
      <div className="flex gap-3">
        {/* Left: Active Call Interface */}
        <div className="flex-1 bg-neutral-900 rounded-xl p-4 border border-neutral-800 min-w-0">
          {/* Status */}
          <div className="flex items-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse flex-shrink-0" />
            <span className="text-[10px] text-green-400 font-semibold tracking-wide uppercase">
              In Call
            </span>
          </div>

          {/* Contact info */}
          <div className="mb-3">
            <p className="text-white font-semibold text-sm leading-tight">
              Marcus Weber
            </p>
            <p className="text-neutral-500 text-[11px]">
              Growth Director · Acme Corp
            </p>
          </div>

          {/* Timer */}
          <div className="text-2xl font-mono text-white font-medium mb-3">
            02:34
          </div>

          {/* Waveform */}
          <div className="flex items-center gap-[2px] h-8 mb-4">
            {[3, 6, 4, 8, 5, 7, 3, 9, 6, 4, 8, 5, 7, 3, 6, 9, 5, 4, 7, 6, 8, 3, 5].map(
              (h, i) => (
                <div
                  key={i}
                  className="w-1 rounded-full bg-blue-500 opacity-80"
                  style={{ height: `${h * 3}px` }}
                />
              )
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-2">
            <button className="flex-1 rounded-lg bg-neutral-800 py-1.5 text-neutral-300 text-[11px] font-medium hover:bg-neutral-700 transition-colors">
              Mute
            </button>
            <button className="flex-1 rounded-lg bg-red-600 py-1.5 text-white text-[11px] font-medium">
              Hang Up
            </button>
            <button className="flex-1 rounded-lg bg-neutral-800 py-1.5 text-neutral-300 text-[11px] font-medium hover:bg-neutral-700 transition-colors">
              Record
            </button>
          </div>
        </div>

        {/* Right: Call Documentation */}
        <div className="flex-1 bg-neutral-900 rounded-xl p-4 border border-neutral-800 min-w-0">
          {/* Header */}
          <div className="flex items-center justify-between mb-3">
            <span className="text-[11px] font-semibold text-neutral-300">
              Call Summary
            </span>
            <span className="text-[10px] bg-green-900/60 text-green-400 px-2 py-0.5 rounded-full font-medium border border-green-800/50">
              Interested ✓
            </span>
          </div>

          {/* AI Summary */}
          <p className="text-[11px] text-neutral-400 mb-3 leading-relaxed">
            Lead showed strong interest in the enterprise plan. Requested a full
            pricing breakdown and asked about team onboarding timeline.
          </p>

          {/* Next Steps */}
          <p className="text-[10px] font-semibold text-neutral-300 mb-2 uppercase tracking-wide">
            Next Steps
          </p>
          <ul className="space-y-1.5">
            <li className="flex items-start gap-1.5 text-[11px] text-neutral-400">
              <div className="w-1.5 h-1.5 rounded-full bg-blue-500 flex-shrink-0 mt-1" />
              Send pricing proposal by EOD
            </li>
            <li className="flex items-start gap-1.5 text-[11px] text-neutral-400">
              <div className="w-1.5 h-1.5 rounded-full bg-blue-500 flex-shrink-0 mt-1" />
              Schedule product demo for next week
            </li>
          </ul>

          {/* Auto-generated label */}
          <p className="mt-3 text-[10px] text-neutral-600">
            Generated automatically · just now
          </p>
        </div>
      </div>

      {/* Bottom: Workflow trigger notification */}
      <div className="mt-3 bg-blue-950/40 border border-blue-900/40 rounded-xl p-3 flex items-center gap-3">
        <div className="flex-shrink-0 w-6 h-6 rounded-lg bg-blue-900/60 border border-blue-800/50 flex items-center justify-center">
          <svg
            className="w-3 h-3 text-blue-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        </div>
        <div className="min-w-0">
          <p className="text-[11px] text-blue-300">
            <span className="text-blue-400 font-semibold">
              Workflow triggered:
            </span>{" "}
            Send pricing email → Move to Negotiation stage
          </p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-[10px] text-neutral-600">just now</span>
        </div>
      </div>
    </div>
  );
};
